import React, { useEffect, useState } from "react";
import LeftBar from "../Components/LeftBar";
import NavBarAccount from "../Components/NavBarAccount";
import { getFirestore, collection, query, where, getDocs, orderBy, updateDoc, setDoc, Timestamp, doc, getDoc } from "firebase/firestore";
import { Modal, Button, Form, Table, Alert } from "react-bootstrap";
import { app } from "../firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import swal from 'sweetalert'; 
import {useNavigate } from "react-router-dom"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFlag, faPersonShelter } from "@fortawesome/free-solid-svg-icons";
import dashOne from '../Images/dashone.svg'


function Dashboard() {

    const db = getFirestore();
    const auth = getAuth();
    const [userId, setUserId] = useState("");
    const [userName, setUserName] = useState();
    const [pointValue, setPointValue] = useState("");
    const [status, setStatus] = useState("");
    const [subscriptionStatus, setSubscriptionStatus] = useState("Unsubscribed");
    const [purchasedSMS, setPurchasedSMS] = useState();
    const [myissuedSMS, setMyissuedSMS] = useState();
    const [myTotalSMS, setMyTotalSMS] = useState();

    const [businessLocation, setbusinessLocation] = useState("Set Location")
  
    const [totalPoints, setTotalPoints] = useState(0);
    const [redeemedPoints, setRedeemedPoints] = useState(0);
    const [uniquePhoneCount, setUniquePhoneCount] = useState(0);



    useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        if (user) {
          const uid = user.uid;
          setUserId(uid);
          loadSettings(uid);
          fetchUserStatus(uid);
          fetchTotalAwardedPoints(uid);
          fetchTotalRedeemedPoints(uid);
          countUniquePhones(uid);
        }
      });
      return () => unsubscribe();
    }, []);

      const loadSettings = async (uid) => {
        const docRef = doc(db, "settings", uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setPointValue(data.pointValue || "");   
          setbusinessLocation(data.county || "Set Location")
        }
      };
    
      const fetchUserStatus = async (uid) => {
        const userQuery = query(collection(db, "users"), where("userId", "==", uid));
        const querySnapshot = await getDocs(userQuery);
        querySnapshot.forEach((docSnap) => {
          const data = docSnap.data();
          setStatus(data.status || "Unsubscribed");
          setUserName(data.businessName);
          setPurchasedSMS(data.purchasedSMS);
          setMyissuedSMS(data.issuedSMS);
          const totalSMS = parseInt(data.issuedSMS) + data.purchasedSMS;
          setMyTotalSMS(totalSMS);
    
          const subscriptionEnd = data.subscriptionEnd?.toDate?.();
          if (subscriptionEnd) {
            const now = new Date();
            const isExpired = now > subscriptionEnd;
            setSubscriptionStatus(isExpired ? "Expired" : "Active");
          } else {
            setSubscriptionStatus("Unsubscribed");
          }
        });
      };
    
      const fetchTotalAwardedPoints = async (uid) => {
        const rewardRef = collection(db, "rewardCustomers");
        const q = query(rewardRef, where("businessId", "==", uid));
        
        try {
          const querySnapshot = await getDocs(q);
          let total = 0;
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            total += data.points || 0;
          });
          setTotalPoints(total);
        } catch (error) {
          console.error("Error fetching awarded points:", error);
        }
      };

      const fetchTotalRedeemedPoints = async (uid) => {
        const redeemedRef = collection(db, "redeemedPoints");
        const q = query(redeemedRef, where("businessId", "==", uid));

        try {
          const querySnapshot = await getDocs(q);
          let total = 0;
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            total += data.pointsUsed || 0;
          });
          setRedeemedPoints(total);
        } catch (error) {
          console.error("Error fetching redeemed points:", error);
        }
      };


      const countUniquePhones = async (uid) => {
        const rewardRef = collection(db, "rewardCustomers");
        const q = query(rewardRef, where("businessId", "==", uid));

        try {
          const querySnapshot = await getDocs(q);
          const phoneSet = new Set();

          querySnapshot.forEach((doc) => {
            const data = doc.data();
            if (data.phone) {
              phoneSet.add(data.phone);
            }
          });

          setUniquePhoneCount(phoneSet.size);
        } catch (error) {
          console.error("Error counting unique phone numbers:", error);
        }
      };



  


 
   return (
     <div className="dashBCont">
       <LeftBar />
       <div className="dashBcontA">
         <NavBarAccount />
         <div className="DashContent">

          <div className="dashChild1">

            <div className="dash1">
              <div className="dash1Cont">
                <h2>Welcome</h2>
                <p>{userName}</p>
                </div>
                <img src={dashOne} alt="" />
            </div>

            <div className="dash2">

              <div className="dash2child">
                <p>SMS Balance</p>
                <h4>{myTotalSMS}</h4>
              </div>
              <div className="dash2child">
                <p>Points Awarded</p>
                <h4>{totalPoints}</h4>
              </div>

              <div className="dash2child">
                <p>Points Redeemed</p>
                <h4>{redeemedPoints}</h4>
              </div>
              <div className="dash2child">
                <p>Business Location</p>
                <p>{businessLocation}</p>
              </div>

              <div className="dash2child">
                <p>Active Customers</p>
                <h4>{uniquePhoneCount}</h4>
              </div>

              <div className="dash2child">
                <p>Points Value (KES)</p>
                <h4>{pointValue}</h4>
              </div>


            </div>

          </div>

            <h4 className="mt-5 mb-4">Notifications</h4>

            <table className="min-w-full w-100 bg-white border border-gray-200 mt-6">
              <thead>
                  <tr className="bg-gray-100 text-left">
                      <th className="p-3 border-b">Date</th>
                      <th className="p-3 border-b">Message</th>
                      <th className="p-3 border-b">Action</th>
                  </tr>
              </thead>
              <tbody>
                 
              </tbody>
          </table>




         </div>
       </div>
     </div>
   );
}


export default 
Dashboard